export default __webpack_public_path__ + "static/media/minus.9d3da73a.svg";